import styled from "@emotion/styled";

export const Text = styled("p")`
  font-size: 16px;
`;
